import { render } from "./ServiceAll.vue?vue&type=template&id=58f2d7e6&scoped=true"
import script from "./ServiceAll.vue?vue&type=script&lang=js"
export * from "./ServiceAll.vue?vue&type=script&lang=js"

import "./ServiceAll.vue?vue&type=style&index=0&id=58f2d7e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f2d7e6"]])

export default __exports__